import { Carrot } from "@/components/Carrot";

/**
 * A galloping horse pictogram, drawn in the same hand-cut style as the brand
 * carrot — simple filled shapes, slightly naive proportions.
 */
function Horse(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 96 64" fill="currentColor" aria-hidden="true" {...props}>
      {/* tail */}
      <path d="M32 28 C22 26 13 19 8 8 C14 11 20 15 25 20 C28 23 30 25 33 26 Z" />
      {/* legs — full gallop stretch */}
      <g stroke="currentColor" strokeWidth="6" strokeLinecap="round" fill="none">
        <path d="M33 39 L16 54" />
        <path d="M38 40 L32 58" />
        <path d="M56 40 L62 57" />
        <path d="M60 38 L76 52" />
      </g>
      {/* body */}
      <ellipse cx="46" cy="32" rx="21" ry="10.5" />
      {/* neck + head, reaching for the carrot */}
      <path d="M52 30 C56 18 62 10 70 5 C74 1 79 1 83 4 L93 10 C94 13 90 15 86 13 C82 12 79 13 76 16 C71 21 66 26 61 33 Z" />
      {/* ear */}
      <path d="M73 5 L76 -3 L81 3 Z" />
    </svg>
  );
}

/**
 * The brand metaphor, made literal: a tiny horse trots along the bottom edge
 * of the sticky nav as you scroll, chasing the carrot waiting at the far end
 * of the page — and finally catches it when you reach the bottom.
 *
 * Driven entirely by CSS scroll timelines (see .chase-* in index.css): no JS
 * scroll listeners. Hidden when animation-timeline is unsupported and under
 * prefers-reduced-motion.
 */
export function ChaseProgress() {
  return (
    <div aria-hidden className="chase pointer-events-none absolute inset-x-0 -bottom-px h-px">
      {/* the trodden path (ground covered so far) */}
      <div className="chase-track absolute inset-0 origin-left bg-field" style={{ transform: "scaleX(0)" }} />
      {/* the carrot, waiting at the end of the page — pops when caught */}
      <span className="chase-carrot absolute -top-[15px] right-1 inline-block">
        <Carrot className="h-4 w-4 rotate-[24deg]" />
      </span>
      {/* the horse: outer runner sweeps the full track width, inner counter
          pulls back by the horse's own width so it never overshoots */}
      <div className="chase-runner absolute inset-x-0 -top-[15px]">
        <div className="chase-horse inline-block">
          <Horse className="h-4 w-auto text-ink/60" />
        </div>
      </div>
    </div>
  );
}
